const enum AppRoleEnum {
  TENANT = 'TENANT',
  LANDLORD = 'LANDLORD',
}
type AppRole = AppRoleEnum.TENANT | AppRoleEnum.LANDLORD;

interface AppApiError {
  error: boolean;
  role?: undefined | AppRole;
}

export { AppRoleEnum, AppRole, AppApiError };
